module.exports = __webpack_public_path__ + "static/media/CognitiveModel.8c9471df.svg";